import type { PaginationMeta } from '@access-cms/api-client';

import { getTableResultSummary } from '../../utils';
import './TableResultSummary.css';

export interface TableResultSummaryProps {
  pagination?: Partial<PaginationMeta>;
  rowCount: number;
  'data-testid'?: string;
}

function TableResultSummary({
  pagination,
  rowCount,
  'data-testid': dataTestId = 'table-result-summary',
}: TableResultSummaryProps) {
  const summary = getTableResultSummary(pagination, rowCount);

  if (!summary) return null;

  return (
    <div
      className='access-table-summary'
      data-testid={dataTestId}>
      <p data-testid={`${dataTestId}-records-summary`}>{summary}</p>
    </div>
  );
}

export default TableResultSummary;
